module.exports = __webpack_public_path__ + "img/Harmonie-assurance.6773bc05.png";